module.exports = __webpack_public_path__ + "img/redx-hollow.8bb523f4.svg";